import { defineMessages } from 'react-intl.macro';

const messages = defineMessages({
    descriptionHeading: {
        id: 'classMain.description.heading',
        description: 'Heading for classroom description section',
        defaultMessage: 'Description',
    },
    userKey: {
        id: 'classMain.userKey',
        description: 'Label for displayed user key',
        defaultMessage: 'Account ID:',
    },
});

export default messages;
